import script from "./AffiliatesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AffiliatesView.vue?vue&type=script&lang=ts&setup=true"

import "./AffiliatesView.vue?vue&type=style&index=0&id=24f42174&lang=scss"

const __exports__ = script;

export default __exports__